import { FC, memo } from "react";
import { Box, Typography } from "@mui/material";
import { uniqueBy } from "../../../orderBook";
import { GRIDS } from "../../../orderBook/allGrids";
import { useSelectedArea } from "../../atoms/selectedGrid";
import { ALL_GRIDS } from "./constants";

const uniqueGrids = uniqueBy(
  GRIDS.filter((x) => x.deleted === false && x.ProductDurations.length > 0),
  "eicCode"
);

export const areaOptions = [
  { code: ALL_GRIDS, label: "All", eicCodes: [] as string[] },
  // `code` ends up in the URL (algosArea) and `label` on the chip, so both use the
  // readable name; only `eicCodes` carries the wire identifier the hub filters on.
  ...uniqueGrids.map((grid) => ({
    code: grid.displayName,
    label: grid.displayName,
    eicCodes: [grid.eicCode, grid.displayName],
  })),
];

/**
 * The area filter, shared by the algos and trades grids from the view toolbar.
 * Ten options is more than the bar can always fit, so the row scrolls sideways
 * rather than pushing the search box and the view toggle off the edge.
 */
const AreaSelectorComp: FC = () => {
  const [selectedArea, setSelectedArea] = useSelectedArea();

  const handleAreaChange = (area: string) => {
    if (area === selectedArea) {
      setSelectedArea(ALL_GRIDS);
    } else {
      setSelectedArea(area);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 1.5,
        minWidth: 0,
        overflowX: "auto",
        // The bar is only 42px tall; a scrollbar inside it would eat the text.
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {areaOptions.map((option) => (
        <Box
          key={option.code}
          onClick={() => handleAreaChange(option.code)}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <Typography
            color={option.code === selectedArea ? "primary" : undefined}
            variant="body2"
            noWrap
          >
            {option.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export const AreaSelector = memo(AreaSelectorComp);
